export default {
    cz: {
        title: 'Použité filtry',
        specificParams: 'Upřesnit parametry',
        clearAll: 'Zrušit všechny filtry',
        close: 'Zavřít',
        chooseStoreTitle: 'Zjistit dostupnost v prodejnách?',
        chooseStoreButton: 'Vyberte si prodejnu',
    },
    sk: {
        title: 'Použité filtre',
        specificParams: 'Upresniť parametre',
        clearAll: 'Zrušiť všetky filtre',
        close: 'Zavrieť',
        chooseStoreTitle: 'Zistiť dostupnosť v predajniach?',
        chooseStoreButton: 'Vyberte si predajňu',
    },
}
